import {Subscription} from "rxjs";
import {NgClass} from "@angular/common";
import {Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output} from '@angular/core';

import {ToastrService} from "ngx-toastr";

import {UserAdLikeApiService} from "@numizmat/services/core";
import {UserAdLikeRequest} from "@numizmat/services-models/core";
import {CurrentUserStateService} from "@numizmat/services/account";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LoginModalComponent} from "@numizmat/modals";

@Component({
  selector: 'nz-toggle-ad-like-button',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './toggle-ad-like-button.component.html',
  styleUrl: './toggle-ad-like-button.component.scss'
})
export class ToggleAdLikeButtonComponent implements OnInit, OnDestroy {
  private modalService: NgbModal = inject(NgbModal);
  private toastrService: ToastrService = inject(ToastrService);
  private userAdLikeApiService: UserAdLikeApiService = inject(UserAdLikeApiService);
  private currentUserStateService: CurrentUserStateService = inject(CurrentUserStateService);

  @Input() adId!: string;
  @Input() disabled: boolean = false;
  @Input() userAdLikeId?: string;
  @Output() onLike: EventEmitter<string> = new EventEmitter<string>();
  @Output() onDislike: EventEmitter<void> = new EventEmitter<void>();

  private subs: Subscription = new Subscription();

  private userLoggedIn: boolean = false;
  private toggleLikeLoading: boolean = false;

  public ngOnInit(): void {
    this.getCurrentUser();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected onToggleLike(): void {
    if (this.toggleLikeLoading || this.disabled) {
      return;
    }
    if (!this.userLoggedIn) {
      this.modalService.open(LoginModalComponent, {
        scrollable: true
      });
      return;
    }
    this.toggleLikeLoading = true;
    if (!!this.userAdLikeId) {
      this.userAdLikeApiService.deleteUserAdLike(this.userAdLikeId).subscribe({
        next: response => {
          this.toggleLikeLoading = false;
          if (!!response) {
            this.onDislike.emit();
            this.userAdLikeId = undefined;
            this.toastrService.success('Успешно премахнахте обява от списъка с харесани.');
          } else {
            this.toastrService.error('Възникна грешка.');
          }
        }
      });
    } else {
      const response: UserAdLikeRequest = {
        adId: this.adId,
      };
      this.userAdLikeApiService.insertUserAdLike(response).subscribe({
        next: response => {
          this.toggleLikeLoading = false;
          if (!!response) {
            this.onLike.emit(response);
            this.userAdLikeId = response;
            this.toastrService.success('Успешно добавихте обява към списъка с харесани.');
          } else {
            this.toastrService.error('Възникна грешка.');
          }
        }
      });
    }
  }

  private getCurrentUser(): void {
    const subscription: Subscription = this.currentUserStateService.getCurrentUser().subscribe({
      next: currentUser => {
        this.userLoggedIn = currentUser?.loggedIn;
      }
    });
    this.subs.add(subscription);
  }
}
